angular.module('trainerWebApp.services')
  .factory('trackingService', ['$resource', 'gac', 'mtypes', '$window', function($resource, gac, mtypes, $window) {
    var kissMetricsDefaults = {};

    var lastEvent = {
      category: null,
      action: null,
      time: 0
    };

    function trackEvent(category, action) {
      var event = {
        category: category,
        action: action,
        time: new Date().time
      };

      if(ignoreEvent(event)) return;
      lastEvent = event;
      resolveGa('send', 'event', event.category, event.action, mfConfig.permissionsName);
    }

    function trackPageView(pageName) {
      _gaq.push(['_trackPageview', pageName]);
      resolveGa('send', 'pageview', pageName);
    }

    function ignoreEvent(event) {
      return typeof ga === 'undefined'
        || (
          lastEvent
          && lastEvent.time > event.time - 1000
          && lastEvent.category == event.category
          && lastEvent.action == event.action
          );
    }

    function kissMetricsEnabled() {
      return typeof _kmq != 'undefined';
    }

    function setupKissMetrics(params) {
      if(!kissMetricsEnabled()) {
        return;
      }

      _kmq.push(['identify', params.userId.toString()]);

      kissMetricsDefaults["Account ID"] = params.accountId;
      kissMetricsDefaults["User ID"] = params.userId;
      kissMetricsDefaults["Company Name"] = params.accountInfo.companyName;
      kissMetricsDefaults["User Role"] = mfConfig.permissionsName;
    }

    function trackKissMetricsEvent(event, params) {
      if(!kissMetricsEnabled()) {
        return;
      }

      _kmq.push(['record', event, _.defaults(params || {}, kissMetricsDefaults)]);
    }

    function resolveGa() {
      if(!$window.ga)
        return;
      $window.ga.apply(null, arguments);
    }


    return {
      trackEvent: trackEvent,
      trackPageView: trackPageView,
      setupKissMetrics: setupKissMetrics,
      trackKissMetricsEvent: trackKissMetricsEvent,
      pages: gac.pages
    };

  }]);
